export enum UserType {
  UNVERIFIED = '',
  PENDING = 'pending',
  /**
   * @deprecated When setting this value, you should use the new property landlordType with values from the `LandlordType` enum instead.
   */
  STUDENT = 'student',
  LANDLORD = 'landlord',
  UNDER_REVIEW = 'under-review',
}

export enum LandlordType {
  STUDENT = 'student',
  PRIVATE_LANDLORD = 'private-landlord',
  RENTAL_COMPANY = 'rental-company',
  OTHER = 'other',
}
